module.exports = __webpack_public_path__ + "img/03.dd440941.jpg";